document.addEventListener("DOMContentLoaded",(function(){}));